import NewTabLinkRenderer from 'components/AgGrid/NewTabLinkRenderer'
import DesignationRenderer from 'components/Metadata/Summary/ObmEmployee/DesignationRenderer'

export const columnDefs = [
  {
    headerName: 'Full name',
    field: 'fullname',
    maxWidth: '350',
    suppressMenu: true,
    floatingFilter: false,
    cellRenderer: 'newTabLinkRenderer',
    cellRendererParams: {
      to: '/Metadata/OBMEmployee',
      linkIdentification: 'email',
      contentField: 'fullname',
    },
  },
  {
    headerName: 'Email',
    field: 'email',
    maxWidth: '300',
    suppressMenu: true,
    floatingFilter: false,
  },
  {
    headerName: 'Designation',
    field: 'designation',
    suppressMenu: true,
    floatingFilter: false,
    cellRenderer: 'designationRenderer',
    cellRendererParams: {
      contentField: 'designation',
    },
  },
]

/**
 * This is for react component, the component content will not be wrapped in a cell
 * @type {{newTabLinkRenderer}}
 */
export const frameworkComponents = {
  newTabLinkRenderer: NewTabLinkRenderer,
  designationRenderer: DesignationRenderer,
}

/**
 * If you need your component to be wrapped in a cell, you need to use component
 */
export const components = {}
